import React, { memo, ReactNode } from 'react';
import { useDialog } from '../dialog.context';

type CloseProps = {
  children?: ReactNode;
  asChild?: boolean;
};

export const Close = memo(({ children, asChild }: CloseProps) => {
  const { close } = useDialog();

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, { onClick: close });
  }

  return <button onClick={close}>{children || 'Закрыть'}</button>;
});

Close.displayName = 'Dialog.Close';
